import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { mapWorkerToDto, Worker, WorkerDto } from "@/models";
import {
  getPersonalInfoQueryOptions,
  getWorkerQueryOptions,
  getWorkersQueryOptions,
} from "./get.hooks";

export function useDeleteWorker(opts?: {
  onSuccess?: () => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (worker: Worker) =>
      api.deleteEntity<WorkerDto, void>(
        `/api/workers`,
        mapWorkerToDto(worker),
        undefined,
      ),
    onSuccess: (_, { id }) => {
      queryClient.setQueryData(getWorkersQueryOptions.queryKey, (old) =>
        old?.filter((w) => w.id !== id),
      );
      queryClient.resetQueries({
        queryKey: getWorkerQueryOptions(id).queryKey,
      });
      queryClient.invalidateQueries({
        queryKey: getPersonalInfoQueryOptions.queryKey,
      });
      toast({
        title: "toast.workerDeleted",
        variant: "success",
      });
      opts?.onSuccess?.();
    },
    onError: () => {
      toast({
        title: "toast.deleteWorkerError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
